import { on } from "@ngrx/store";
import { QuotesActions } from "./quotes.actions";
import { UserActions } from "../../../user/user.actions";
import { PagesStore } from "../../pages.state";

// ============================================================================
// QUOTES LIST REDUCER
// ============================================================================

const load = on(
    QuotesActions.load,
    (state: PagesStore, action) => {
        const current = state.quote.quotes;
        return {
            ...state,
            quote: {
                ...state.quote,
                quotes: {
                    ...current,
                    loading: true,
                    sortProperty: action.sorting?.sortProperty !== undefined ? action.sorting?.sortProperty : current.sortProperty,
                    sortAscending: action.sorting?.sortAscending !== undefined ? action.sorting?.sortAscending : current.sortAscending,
                    searchFilter: action.searchFilter !== undefined ? action.searchFilter : current.searchFilter,
                    selectedStatuses: action.selectedStatuses !== undefined ? action.selectedStatuses : current.selectedStatuses,
                    selectedTypes: action.selectedTypes !== undefined ? action.selectedTypes : current.selectedTypes,
                    customerCode: action.customerCode !== undefined ? action.customerCode : current.customerCode,
                    customerName: action.customerName !== undefined ? action.customerName : current.customerName,
                    salesPersonCode: action.salesPersonCode !== undefined ? action.salesPersonCode : current.salesPersonCode,
                    salesSupportPersonCode: action.salesSupportPersonCode !== undefined ? action.salesSupportPersonCode : current.salesSupportPersonCode,
                    locationCode: action.locationCode !== undefined ? action.locationCode : current.locationCode,
                    createdFrom: action.createdFrom !== undefined ? action.createdFrom : current.createdFrom,
                    createdTo: action.createdTo !== undefined ? action.createdTo : current.createdTo,
                    validToFrom: action.validToFrom !== undefined ? action.validToFrom : current.validToFrom,
                    validToTo: action.validToTo !== undefined ? action.validToTo : current.validToTo,
                },
            },
        };
    },
);

const loadSuccess = on(
    QuotesActions.loadSuccess,
    (state: PagesStore, { quotes, pagination }) => ({
        ...state,
        quote: {
            ...state.quote,
            quotes: {
                ...state.quote.quotes,
                quotes,
                loaded: true,
                loading: false,
                pagination,
            },
            error: null,
        },
    }),
);

const loadFailure = on(
    QuotesActions.loadFailure,
    (state: PagesStore, { error }) => ({
        ...state,
        quote: {
            ...state.quote,
            quotes: { ...state.quote.quotes, loading: false },
            error,
        },
    }),
);

const invalidate = on(
    QuotesActions.invalidate,
    UserActions.changeCompanySuccess,
    (state: PagesStore) => ({
        ...state,
        quote: {
            ...state.quote,
            quotes: { ...state.quote.quotes, loaded: false },
        },
    }),
);

const setVisibleColumns = on(
    QuotesActions.setVisibleColumns,
    (state: PagesStore, { visibleColumns }) => ({
        ...state,
        quote: {
            ...state.quote,
            quotes: { ...state.quote.quotes, visibleColumns },
        },
    }),
);

export const quotesReducer = [load, loadSuccess, loadFailure, invalidate, setVisibleColumns];
